import {Component, OnDestroy, OnInit} from '@angular/core';
import {PlatformQueryService} from '@core/services/platform-query.service';
import {PlatformQueryResponse} from '@shared/models/platform-query/platform-query';
import {HomeSideBarItem} from '@shared/models/platform-tool-models';
import {take, takeUntil} from 'rxjs/operators';
import {Subject} from 'rxjs';
import {TaskManagerService} from '@features/task-manager/services/task-manager.service';
import {Pillar2complianceHandler} from '@features/scenarios-core/services/handlers/pillar2compliance-handler.service';
import {
  Pillar2ComplianceLegends,
  Pillar2ComplianceLegendsGroup
} from '../../../models/pillar2-compliance-legends.model';

@Component({
  standalone: false,
  selector: 'app-pillar2-compliance-legends',
  templateUrl: './pillar2-compliance-legends.component.html',
  styleUrl: './pillar2-compliance-legends.component.scss'
})
export class Pillar2ComplianceLegendsComponent implements OnInit, OnDestroy {
  public homeSideBarItem: HomeSideBarItem;
  protected legendsModel: Pillar2ComplianceLegends = new Pillar2ComplianceLegends();
  private readonly unsubscribe$ = new Subject<void>();

  constructor(
    private platformQueryService: PlatformQueryService,
    private taskManagerService: TaskManagerService,
    private pillar2Handler: Pillar2complianceHandler
  ) {}

  ngOnInit(): void {
    this.getLegends();
    this.pillar2Handler.settingsChanged$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(() => this.getLegends());
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  private getLegends(): void {
    if (this.homeSideBarItem?.query) {
      this.platformQueryService.executeQuery(this.homeSideBarItem.query)
        .pipe(take(1))
        .subscribe((response: PlatformQueryResponse) => {
          this.legendsModel = response.fieldValues['Pillar2ComplianceLegends'];
        });
    }
  }

  protected onSettings(group: Pillar2ComplianceLegendsGroup): void {
    if (group.settingsBoardId) {
      this.taskManagerService.openTaskStatusSettings(group.settingsBoardId, 1)
        .pipe(take(1))
        .subscribe(result => {
          if (result?.action === 'OK') {
            this.getLegends();
          }
        });
    }
  }
}
